import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
      setIsMobileMenuOpen(false);
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const goToDownload = () => {
    navigate('/download');
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/80 backdrop-blur-lg shadow-sm' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <div className="flex items-center space-x-0 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="/drivault-logo.png" 
              alt="Drivault" 
              className="h-8 w-8 md:h-10 md:w-10 object-contain"
            />
            <span className="text-xl md:text-2xl font-bold text-gray-900">Drivault</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium">
              Features
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium">
              How It Works
            </button>
            <button onClick={goToDownload} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium">
              Download
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium">
              Pricing
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium">
              FAQ
            </button>
            <Button 
              onClick={() => scrollToSection('waitlist')}
              className="bg-[#40E095] hover:bg-[#36C981] text-white font-semibold px-6 transition-all hover:shadow-lg hover:scale-105"
            >
              Request Invite
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-gray-700 hover:text-[#40E095] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-white shadow-lg border-t">
            <nav className="flex flex-col p-4 space-y-4">
              <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium text-left py-2">
                Features
              </button>
              <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium text-left py-2">
                How It Works
              </button>
              <button onClick={goToDownload} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium text-left py-2">
                Download
              </button>
              <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium text-left py-2">
                Pricing
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-[#40E095] transition-colors font-medium text-left py-2">
                FAQ
              </button>
              <Button 
                onClick={() => scrollToSection('waitlist')}
                className="bg-[#40E095] hover:bg-[#36C981] text-white font-semibold transition-all"
              >
                Request Invite
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
